<template>
  <el-drawer title="会员七类特种病补助申请表" :before-close="close" :visible.sync="drawerVisible" @opened="drawOpen" direction="rtl"
    :wrapperClosable='false' class="demo-drawer" ref="drawer">
    <div class="demo-drawer__content">
      <el-form ref="form" :model="form" :label-width="formLabelWidth" v-loading="loading" element-loading-text="提交中..."
        class="formbirth d2-mr-10" size="small">
        <el-form-item label="申请人" prop="SQR" :rules="[ { required: true, message: '申请人不能为空', trigger: 'blur' }]">
          <el-input v-model="form.SQR" autocomplete="off" placeholder="请输入申请人姓名" readonly></el-input>
        </el-form-item>
        <el-form-item label="补助类型" prop="TypeName" :rules="[{ required: true, message: '补助类型不能为空', trigger: 'blur' }]">
          <el-input v-model="form.TypeName" autocomplete="off" placeholder="请输入补助类型" readonly></el-input>
        </el-form-item>
        <el-form-item label="AD账号" prop="GH" :rules="[{ required: true, message: 'AD账号不能为空', trigger: 'blur' }]">
          <el-input v-model="form.GH" autocomplete="off" placeholder="请输入AD账号" readonly></el-input>
        </el-form-item>
        <el-form-item label="部门" prop="BM" :rules="[{ required: true, message: '部门不能为空', trigger: 'blur' }]">
          <el-input v-model="form.BM" autocomplete="off" placeholder="请输入部门" readonly></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="XB" :rules="[{ required: true, message: '性别不能为空', trigger: 'blur' }]">
          <el-select v-model="form.XB" placeholder="请选择性别" class="w100">
            <el-option v-for="val in sexOption" :label="val.label" :value="val.value" :key="val.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄" prop="NL" :rules="[{ required: true, message: '年龄不能为空', trigger: 'blur' }]">
          <el-input-number v-model="form.NL" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item label="手机号码" prop="SJHM"
          :rules="[{ required: true, validator: rulesUtils.validatePhone, trigger: 'blur'}]">
          <el-input placeholder="请输入手机号码" :value="!phoneVisible && !scan?judgePhone(form.SJHM):form.SJHM"
            @input="form.SJHM = $event" @focus="!scan?phoneVisible=true:''" @blur="!scan?phoneVisible=false:''">
            <i slot="suffix" :class="!phoneVisible?'el-icon-view':'el-icon-error'"
              :title="!phoneVisible?'查看完整手机号码':'脱敏手机号码'" @click="IsPhoneHandle(phoneVisible)"></i></el-input>
        </el-form-item>
        <el-form-item label="确诊日期" prop="EventDate" :rules="[{required: true, message: '确诊日期不能为空', trigger: 'blur'}]">
          <el-date-picker v-model="form.EventDate" type="date" placeholder="请输入确诊日期" class="w100" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="疾病种类" prop="JBZL">
          <el-checkbox-group v-model="form.JBZL">
            <el-checkbox v-for="(item,index) in diseaseList" :key="index" :label="item.JBZL"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="申请人开户银行" prop="SQRKHYH"
          :rules="[{ required: true, message: '开户银行不能为空', trigger: 'blur' }]">
          <el-input placeholder="请输入开户银行" v-model.trim="form.SQRKHYH"></el-input>
        </el-form-item>
        <el-form-item label="银行账号" prop="YHZH"
          :rules="[{ required: true, validator: rulesUtils.validateBankNum, trigger: 'blur'}]">
          <el-input placeholder="请输入银行账号" v-model.trim="form.YHZH" type="number"></el-input>
        </el-form-item>
        <el-form-item label="证明材料" prop="Files" :rules="[{ required: true, message: '附件不能为空', trigger: 'blur'}]">
          <el-upload ref="upload" class="avatar-uploader" action="#" accept=".jpeg,.png,.jpg,.pdf,.docx,.doc,xlsx,.xls"
            :before-upload="beforeAvatarUpload" :http-request="uploadFile" :before-remove="beforeRemove"
            :on-remove="handleRemove" :limit="10" list-type="picture-card"
            :on-exceed="handleExceed">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="疾病描述及申请理由" prop="JBSQLY" :rules="[{ required: true, message: '原因不能为空', trigger: 'blur' }]">
          <el-input type="textarea" v-model="form.JBSQLY" autocomplete="off" placeholder="请输入原因" rows="3" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer d2-pb-20">
        <el-button type="primary" @click="submitHandle" :loading="loading" :disabled="disable" size="small">
          {{ loading ? "提交中 ..." : "确 定" }}</el-button>
        <el-button @click="close" size="small">取 消</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
  import * as indexService from "@/api/sys/index";
  import dayjs from "dayjs";
  import rules from "@/libs/rules";
  const defualtForm = {
    SQR: "",
    GH: "",
    XB: "",
    NL: "",
    BM: "",
    SJHM: "",
    SQRKHYH: "",
    YHZH: "",
    TypeName: "",
    Files: "",
    JBSQLY: "",
    EventDate: "",
    JBZL: [],
  };
  export default {
    name: "editDiseaseForm",
    props: {
      disease: Object,
      checked: Object,
      value: Boolean,
    },
    data() {
      return {
        loading: false,
        phoneVisible: false,
        scan:false,
        rulesUtils: rules,
        drawerVisible: false,
        formLabelWidth: "120px",
        form: Object.assign({}, defualtForm),
        disable: false,
        filetypes: [
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/msword",
        ], //文件属性
        fileIds: [], //文件id
        index: 0,
        fileList: [],
        diseaseList: [],
        pickerOptions: {
          //日期选择
          disabledDate(date) {
            return date.getTime() > Date.now();
          },
        },
        sexOption: [{
            // 下拉数据
            label: "男",
            value: "男",
          },
          {
            // 下拉数据
            label: "女",
            value: "女",
          },
        ],
      };
    },
    watch: {
      value(val) {
        this.drawerVisible = val;
      },
      drawerVisible(val) {
        this.$emit("input", val);
      },
    },
    computed: {
      unitname() {
        return this.$store.state.d2admin.userInfo.userinfo;
      },
    },
    methods: {
      drawOpen() {
        this.$refs.form.resetFields();
        this.form.SQR = this.unitname.uInfo.Name;
        this.form.GH = this.unitname.uInfo.AdAccount;
        this.form.XB = this.unitname.uInfo.Sex;
        this.form.NL = this.unitname.uInfo.Age;
        this.form.BM = this.unitname.uInfo.Depart;
        this.form.SJHM = this.unitname.uInfo.Mobile;
        this.form.TypeName = this.checked.name;
        indexService.GetIsMember().then((data) => {
          if (data.data.isMember == false) {
            this.$message.warning("此账号不是会员,无法申请");
            setTimeout(() => {
              this.drawerVisible = false;
            }, 2000);
          } else {
            this.GetSubsidyApplyStatus();
            this.GetDiseaseType();
          }
        });
      },
      // 手机号脱敏
      judgePhone(val) {
        if (!val) return ''
        let reg = /^(.{3}).*(.{4})$/
        return val.replace(reg, '$1****$2')
      },
      IsPhoneHandle(flag) {
        this.phoneVisible = !this.phoneVisible;
        this.scan = !this.scan
      },
      GetSubsidyApplyStatus() {
        let query = {
          type: this.checked.name,
          shortTitle: "会员七类特种疾病补助申请",
        };
        indexService.GetSubsidyApplyStatus(query).then((data) => {
          if (data.data.status != -1) {
            this.$message.warning(
              data.data.Actor ? data.data.Actor : "此账号已无法提交"
            );
            this.disable = true;
          } else {
            this.disable = false;
          }
        });
      },
      GetDiseaseType() {
        let query = {
          filter: [{key:"ISEnable",value:"true",sqlOperator:"EN"}],
          limit: 999,
          orderby:[{columnName:"sort",sortType:""}],
          shortTitle: "疾病维护表",
          start: 1,
        };
        indexService.GetDiseaseType(query).then((data) => {
          this.diseaseList = data.data
        });
      },
      submitHandle() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.loading = true;
            let form = {
              childrenData: [],
              dataId: 0,
              mainData: {
                SQR: this.form.SQR,
                GH: this.form.GH,
                XB: this.form.XB,
                NL: this.form.NL,
                BM: this.form.BM,
                SJHM: this.form.SJHM,
                SQRKHYH: this.form.SQRKHYH,
                YHZH: this.form.YHZH,
                TypeName: this.form.TypeName,
                Files: this.form.Files,
                JBSQLY: this.form.JBSQLY,
                JBZL: this.form.JBZL.toString(),
                EventDate: this.form.EventDate,
                Substation: this.unitname.uInfo.Substation,
                JoinMemberDay: this.unitname.uInfo.JoinMemberDay,
                GroupName: this.unitname.uInfo.GroupName,
              },
              shortTitle: this.checked.submitTitle,
            };
            indexService
              .addQuestionData({
                ...form,
              })
              .then((data) => {
                this.$message.success("申请成功！");
                this.drawerVisible = false;
                this.$emit("submit");
                this.close();
              })
              .catch((e) => {
                this.loading = false;
              });
          } else {
            return false;
          }
        });
      },
      //上传图片
      beforeAvatarUpload(file) {
        let isLt2M = file.size < 1024 * 5120;
        let isJPG = ["image/jpeg", "image/png", "image/jpg","image/gif"].includes(file.type);

        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG/PNG/JPEG/GIF 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 5MB!");
        }
        return isJPG && isLt2M;
      },
      handleExceed() {
        this.$message.warning("只能上传10个");
      },
      beforeRemove(file) {
        console.log(file);
        let fileList = this.$refs["upload"].uploadFiles;
        let index = fileList.findIndex((fileItem) => {
          return fileItem.uid === file.uid;
        });
        this.index = index;
        // 本人只能删除本人的文件
        if (file.Creator && util.cookies.get("uuid") != file.Creator) {
          this.$message.warning("只能删除自己上传的文件");
          return false;
        }
        return true;
      },
      handleRemove(file, fileList) {
        if (this.fileIds) {
          this.fileIds.forEach((v, i) => {
            if (this.index == i) {
              this.fileIds.splice(i, 1);
              this.form.Files = this.fileIds.toString();
            }
          });
        }
      },
      //上传图片
      uploadFile(item) {
        let _this = this;
        let formdata = new FormData();
        formdata.append("image", item.file);
        indexService
          .uploadFile(formdata, item.file.name)
          .then((data) => {
            this.$message({
              type: "success",
              message: "图片上传成功!",
            });
            item.onSuccess();
            this.fileIds.push(data.data.filepath);
            this.fileList.push({
              name: data.data.filename,
              url: this.$apiUrl + data.data.filepath,
            });
            this.form.Files = this.fileIds.toString();
          })
          .catch((error) => {
            item.onError();
          });
      },
      close() {
        this.$refs.form.resetFields();
        this.drawerVisible = false;
        this.fileIds = [];
        this.fileList = [];
        this.loading = false;
      },
    },
  };
</script>